
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addCompany, companyList, getAdminCurrencies, getCurrency, UpdateCompany } from "./CompanyRepo"
import ExpenseScreen from "../../../Configuration/Expense Grade/ExpenseScreen"
import { showToast } from "../../../../utils/toastUtils"


interface ReqBodyInterFace{
  CompanyId?:number
  CompanyCode: string,
  CompanyName: string,
  OwnerName: string,
  OwnerEmail: string,
  CompanyPhoneNumber: string,
  CompanyContactNumber:string,
  CompanyAddress1:string,
  CompanyAddress2:string,
  CompanyDefaultCurrency: number | null
 
}

export const useGetCompanyList = ({enable=false,params}:{enable:boolean,params:any})=>{
    return useQuery({
        queryKey:['GET_COMPANY_LIST',params],
        queryFn:()=>companyList(params),
        retry:false,
        enabled:enable
    })
}

export const useGetAdminCurencyList = ({enable=false}:{enable:boolean})=>{
     return  useQuery({
            queryKey:['GET_AdminCurrencies_List'],
            queryFn:getAdminCurrencies,
            retry:false,
            enabled:enable
     })
}

export const useAddCompany =()=>{
    const queryClient = useQueryClient();
    return useMutation({ 
      mutationFn:(ReqBody:ReqBodyInterFace)=>addCompany(ReqBody),
      onSuccess:()=>{
        showToast.success('Compnay added Succefully');
        queryClient.invalidateQueries({queryKey:['GET_COMPANY_LIST']})
      },
      onError:(error:any)=>{
          showToast.error('Falied to add Company');
          console.log(`Failed to Add copany ${error.message}`);
      }
    })
}


export const useUpdateCompany = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:(ReqBody:ReqBodyInterFace)=>UpdateCompany(ReqBody),
        onSuccess:()=>{
        showToast.success('Company Added successfully');
        queryClient.invalidateQueries({queryKey:['GET_COMPANY_LIST']})
       },

       onError:(error:any)=>{
        showToast.error('Failed to update');
        console.log(`Failed to Add Company ${error.message}`);
       }
    })
}

export const useGetCurrency = ({enable=false}:{enable:boolean})=>{
return useQuery({
    queryKey:['GET_CURRENCY'],
    queryFn:getCurrency,
    retry:false,
    enabled:enable
})
}